import React from "react";
import { useQuery } from "@tanstack/react-query";
import { type DropdownMultiWithoutOptionsProps } from "../models";
import BaseMultiSelectDropdown from "./BaseMultiSelectDropdown";

interface Props extends DropdownMultiWithoutOptionsProps<server.dto.RelatedArticle> {
  section: server.dto.PromoSiteSections
}

const RelatedArticleMultiDropdown = (props: Props) => {
  const query = useQuery({
    queryFn: async () => window.CoreApi.Article.Paginated({ page: 1, perPage: 999, published: "noFilter", sort: "internalTitle" }, props.section)
      .then(r => r.data.data)
      .then(r => r.map<server.dto.RelatedArticle>(a => ({ articleId: a.articleId, translations: a.translations }))),
    queryKey: ["article", props.section],
  });

  const getEnglishOrDefaultTranslation = (article: server.dto.RelatedArticle) => {
    return (article.translations.find(t => t.language === "english") || article.translations[0])?.title;
  }

  return <BaseMultiSelectDropdown
    excludeKeys={[]}
    value={props.value}
    onChange={props.onChange}
    options={query.data}
    getLabel={article => getEnglishOrDefaultTranslation(article)}
    getValue={article => article.articleId}
    config={{
      isSearchable: true,
      shouldRenderSelectedValue: true,
      ...props.config
    }}
  />;
};

export default RelatedArticleMultiDropdown;